module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.ToDo === 'false') ? _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.ToDos), function(item) {
    return (!item.status) ? _c('v-col', {
      key: item.id,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', [_c('v-card-title', [_vm._v("\n              " + _vm._s(item.aufgabe) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', [_vm._v(_vm._s(_vm.$filters.date(item.bis, "DD.MM.YYYY")))])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n              " + _vm._s(item.beschreibung) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(item.wer) ? _c('v-chip', [_vm._v(_vm._s(item.wer))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.showModalEdit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), (!item.status) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("check")])], 1) : _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "calc(100vh - 216px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Erledigte Aufgabe")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ToDos), function(item) {
    return (item.status) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.aufgabe))]), _vm._v(" "), _c('td', {
      staticClass: "pl-0 pr-2",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.checkToDo(item)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-0 pr-2",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.showModalEdit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ToDo === 'true') ? _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("ToDo hinzufügen")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Aufgabe"
    },
    model: {
      value: (_vm.aufgabe),
      callback: function($$v) {
        _vm.aufgabe = $$v
      },
      expression: "aufgabe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-menu', {
    ref: "bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBis),
            callback: function($$v) {
              _vm.formatBis = $$v
            },
            expression: "formatBis"
          }
        }, on))]
      }
    }], null, false, 4224442442),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.bis),
      callback: function($$v) {
        _vm.bis = $$v
      },
      expression: "bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Beschreibung"
    },
    model: {
      value: (_vm.beschreibung),
      callback: function($$v) {
        _vm.beschreibung = $$v
      },
      expression: "beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Senior"
    },
    model: {
      value: (_vm.senior),
      callback: function($$v) {
        _vm.senior = $$v
      },
      expression: "senior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Consenior"
    },
    model: {
      value: (_vm.consenior),
      callback: function($$v) {
        _vm.consenior = $$v
      },
      expression: "consenior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Fuxmajor"
    },
    model: {
      value: (_vm.fuxmajor),
      callback: function($$v) {
        _vm.fuxmajor = $$v
      },
      expression: "fuxmajor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Schriftführer"
    },
    model: {
      value: (_vm.schriftführer),
      callback: function($$v) {
        _vm.schriftführer = $$v
      },
      expression: "schriftführer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Kassierer"
    },
    model: {
      value: (_vm.kassierer),
      callback: function($$v) {
        _vm.kassierer = $$v
      },
      expression: "kassierer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Hauswart"
    },
    model: {
      value: (_vm.hauswart),
      callback: function($$v) {
        _vm.hauswart = $$v
      },
      expression: "hauswart"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-12",
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addToDo
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.modalEdit),
      callback: function($$v) {
        _vm.modalEdit = $$v
      },
      expression: "modalEdit"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.itemEdit.aufgabe) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteToDo
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Aufgabe"
    },
    model: {
      value: (_vm.aufgabe),
      callback: function($$v) {
        _vm.aufgabe = $$v
      },
      expression: "aufgabe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-menu', {
    ref: "bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBis),
            callback: function($$v) {
              _vm.formatBis = $$v
            },
            expression: "formatBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.bis),
      callback: function($$v) {
        _vm.bis = $$v
      },
      expression: "bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Beschreibung"
    },
    model: {
      value: (_vm.beschreibung),
      callback: function($$v) {
        _vm.beschreibung = $$v
      },
      expression: "beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Senior"
    },
    model: {
      value: (_vm.senior),
      callback: function($$v) {
        _vm.senior = $$v
      },
      expression: "senior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Consenior"
    },
    model: {
      value: (_vm.consenior),
      callback: function($$v) {
        _vm.consenior = $$v
      },
      expression: "consenior"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Fuxmajor"
    },
    model: {
      value: (_vm.fuxmajor),
      callback: function($$v) {
        _vm.fuxmajor = $$v
      },
      expression: "fuxmajor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Schriftführer"
    },
    model: {
      value: (_vm.schriftführer),
      callback: function($$v) {
        _vm.schriftführer = $$v
      },
      expression: "schriftführer"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Kassierer"
    },
    model: {
      value: (_vm.kassierer),
      callback: function($$v) {
        _vm.kassierer = $$v
      },
      expression: "kassierer"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.modalEdit = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.updateToDo
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82ce9096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/todoSeite.vue
// module id = 796
// module chunks = 15